// Adapter que no hace nada. Se usa cuando falta la API key, cuando el kill
// switch está puesto, y en las rutas que llevan credenciales en la URL.
import type { AnalyticsAdapter } from "../types";

export const noopAdapter: AnalyticsAdapter = {
  name: "noop",
  init() {
    /* no-op */
  },
  track() {
    /* no-op */
  },
  identify() {
    /* no-op */
  },
  register() {
    /* no-op */
  },
  page() {
    /* no-op */
  },
  reset() {
    /* no-op */
  },
};
